import { Injectable } from "@angular/core";
import { Clinic } from "src/app/system/clinic/models/clinic";
import { CustomResult } from "../../../shared/models/custom-result";
import { PageData, PageData2 } from "../../../shared/models/page-data";
import { WebApiClient } from "../../web-api-client.service";
import { WebApiService } from "../../web-api.service";
import { NhiimiSetting } from "src/app/system/clinic/models/nhiimiSetting";
import { Role } from "src/app/permission/role/models/IRole";
import { ConsoleInfo } from "../../hcr-service.service";
import { ParamMap } from "@angular/router";
import { DoctorOption, IValueTextPair, ValueTextPair } from "src/app/shared/models/value-text-pair";
import { ClinicSession } from "./clinic-session-api.service";
import { DxOpt, RsOpt, RxOpt } from "../hist/hist-edit-option";
import { Hspid } from "../hspid/hspid";
import { MedLackArea } from "../medlackarea/medlackarea";
import { PCSxListDto } from "../opd/pcsx/pcsx-api.model";
import { DoctorScheduleDto, RegistDoctorInfo } from "../schedule/schedule-api";
import { DiscountPriorityDto } from "../register/discount-priority-dto";
import { SpecialSameTreatDto } from "../val-addapp/special-sameTreat-dto";
import { PostAreaDto } from "../postarea-api";
import { EnumTypes } from "../../cache-service/enum-cached.service";
import { FullUser } from "../user/user-api";
import { SystemCodeEditOption } from "../system-code/systemcode-api";
import { User } from "src/app/system/user/models/user";
import { DosageDTO } from "../hist/hist-api";
import { Discount } from "src/app/payments/discount/models/discount";
import { TherapistScheduleDto } from "../user/uesrSimpleInfo";
import { NaturalDisasterRxDto } from "../register/natural-disaster-rx-dto";

export class NhiimiListDto {
  Id?: number;
  Stype?: number;
  ATC?: string;
  StdCode?: string;
  RxCode: string;
  Sort: number;
};

export interface RxAtcSyncResult {
  ClinicId: number;
  CandidateCount: number;
  UpdatedCount: number;
  UnmatchedCount: number;
  UnmatchedStdCodes: string[];
}

@Injectable({providedIn:'root'})
export class ClinicApi{
    apiService: WebApiService;
    /**
     *
     */
    constructor(private apiClient: WebApiClient) {
        this.apiService = apiClient.createHisService('system/clinic');
    }
    /**
     * GET system/clinic/Get/{id}
     * 取得診所資料，並由 IHisClinicService 回傳 DTO，含山地標記。
     */
    async Get(id:number): Promise<Clinic>{
        var ret = await this.apiService.get('Get/'+id).toPromise<Clinic>();
        return ret;
    }
    /**
     * PUT system/clinic/Update
     * 傳送 ClinicDto 給後端，呼叫 IHisClinicService 更新診所資訊。
     */
    async Update(clinic :Clinic): Promise<CustomResult>{
        return this.apiService.post('Update',clinic).toPromise();
    }
    /**
     * POST system/clinic/CheckMountain
     * 要求後端判斷診所是否位於山地或離島。
     */
    async CheckMountain(clinic :Clinic): Promise<string>{
        return this.apiService.post('CheckMountain',clinic).toPromise<string>();
    }

    /**
     * POST system/clinic/SystemRepire
     * 封裝還原不同設定段落（系統代碼、參數、編號、折扣等）的 helper。
     */
    async RepireAll(company:number,clinic:number): Promise<void>{
        return this.apiService.post('SystemRepire?companyId='+company+'&clinicId='+clinic+'&sysCode=true&param=true&sysNum=true&regNumRule=true&disount=true',null).toPromise<void>();
    }
    async RepireSystemCode(company:number,clinic:number): Promise<void>{
        return this.apiService.post('SystemRepire?companyId='+company+'&clinicId='+clinic+'&sysCode=true',null).toPromise<void>();
    }
    async RepireParameters(company:number,clinic:number): Promise<void>{
        return this.apiService.post('SystemRepire?companyId='+company+'&clinicId='+clinic+'&param=true',null).toPromise<void>();
    }
    async RepireSystemNumber(company:number,clinic:number): Promise<void>{
        return this.apiService.post('SystemRepire?companyId='+company+'&clinicId='+clinic+'&sysNum=true',null).toPromise<void>();
    }
    async RepireRegNumberRule(company:number,clinic:number): Promise<void>{
        return this.apiService.post('SystemRepire?companyId='+company+'&clinicId='+clinic+'&regNumRule=true',null).toPromise<void>();
    }
    async RepireDiscount(company:number,clinic:number): Promise<void>{
        return this.apiService.post('SystemRepire?companyId='+company+'&clinicId='+clinic+'&discount=true',null).toPromise<void>();
    }
    /**
     * GET system/clinic/GetAll（可帶 code/name 篩選）。
     */
    async GetAll(): Promise<PageData>{
        return this.apiService.get(`GetAll`,
        {
            code:'',
            name:'',
            pageSkip:0,
            pageSize:1000
        }).toPromise();
    }
    /**
     * GET system/clinic/GetList，提供分頁診所清單。
     */
    async GetList(pageNum:number,pageSize:number): Promise<PageData>{

        return this.apiService.get(`GetList`,
        {
            pageSkip:(pageNum-1)*pageSize,
            pageSize:pageSize
        }).toPromise();
    }
    /**
     * GET system/clinic/GetNHIIMISetting
     * 取得診所的 NHI IMI 設定。
     */
    async GetNHIIMISettingAsync(clinicId: number): Promise<NhiimiSetting> {
        return this.apiService.get('GetNHIIMISetting?clinicId='+clinicId).toPromise<NhiimiSetting>();
    }
    /**
     * POST system/clinic/UpdateNHIIMISetting
     * 儲存 NHI IMI 相關參數設定檔。
     */
    async UpdateNHIIMISetting(Model: NhiimiSetting): Promise<string> {
        var result = await this.apiService.post('UpdateNHIIMISetting', Model).toPromise<string>();
        return result;
    }
    /**
     * POST system/clinic/GetNHIIMIList
     * 取得指定 RxCode 的 NHI IMI 列表。
     */
    async GetNHIIMIList(rxCodes: NhiimiListDto[]): Promise<NhiimiListDto[]> {
      var ret: CustomResult = await this.apiService.post('GetNHIIMIList', rxCodes).toPromise<CustomResult>();
      return ret.IsSuccess ? ret.Object : [];
    }
    // async CreateNHIIMISetting(Model: NhiimiSetting): Promise<CustomResult> {
    //     return this.apiService.post('CreateNHIIMISetting', Model).toPromise();
    // }
    /**
     * POST system/clinic/cloneRoleBy
     * 複製角色資料給新的角色。
     */
    async cloneRoleBy(roleId:number, newRole:Role){
        return this.apiService.post('cloneRoleBy',{
            roleId,newRole
        } ).toPromise();
    }
    /**
     * POST system/clinic/UpdateConsoleInfo
     * 更新主控台連線資訊／使用紀錄。
     */
    async UpdateConsoleInfo(info:ConsoleInfo){
        return this.apiService.post('UpdateConsoleInfo',info).toPromise();
    }
    /**
     * GET system/clinic/GetServicePhone/{code}
     * 取得服務電話。
     */
    async GetServicePhone(code: string): Promise<string> {
      return this.apiService.get('GetServicePhone/' + code).toPromise<string>();
    }
    /**
     * GET system/clinic/StartUpPreload
     * 對應 controller 的啟動 preload，聚合參數、系統代碼、排班與列表等。
     */
    async StartUpPreload():Promise<StartUpPreloadDto>{
        return this.apiService.get('StartUpPreload').toPromise<StartUpPreloadDto>();
    }
    /**
     * GET system/clinic/GetHeadquartersClinic
     * 取得總公司診所。
     */
    async GetHeadquartersClinic(): Promise<Clinic> {
        return this.apiService.get('GetHeadquartersClinic').toPromise<Clinic>();
    }
    /**
     * GET system/clinic/GetHeadquartersClinicId
     * 取得總公司診所 ID。
     */
    async GetHeadquartersClinicId(): Promise<number> {
        return this.apiService.get('GetHeadquartersClinicId').toPromise<number>();
    }
    /**
     * POST system/clinic/SyncRxATCFromSRx
     * 從有效 SRx 補回目前院所 Rx 的 ATC。
     */
    async SyncRxATCFromSRx(): Promise<RxAtcSyncResult> {
        return this.apiService.post('SyncRxATCFromSRx', null).toPromise<RxAtcSyncResult>();
    }
}

export interface StartUpPreloadDto {
    param:ParamMap,
    enums:{[key:string]:IValueTextPair<number>[]},
    systemCodes:{[key:string]:IValueTextPair<string>[]},
    clinicSession:ClinicSession[],
    cityArea:PostAreaDto,
    dxOpt:DxOpt[];
    rxOpt:RxOpt[];
    rsOpt:RsOpt[];
    hspids:PageData2<Hspid>;
    medLackArea:MedLackArea[],
    pcsx:PageData2<PCSxListDto>
    gpPara:{gpPara:string};
    schedule:DoctorScheduleDto[]
    doctor:DoctorOption[]
    nhiIMISetting:NhiimiSetting;
    discountPriority:DiscountPriorityDto[]
    discounts:IValueTextPair<string>[]
    naturalDisasterRx:NaturalDisasterRxDto[]
    spcOpt:IValueTextPair<string>[]
    specialSameTreat:SpecialSameTreatDto[]
    executor:IValueTextPair<string>[]
    currentUser:FullUser;
    systemCodeOptions:SystemCodeEditOption;
    pharmacist:IValueTextPair<number>[];
    schePhar:DoctorScheduleDto[];
    dosages:DosageDTO[];
    regDoctors:RegistDoctorInfo,
    ageDiscount: Discount[],
    RehabitMedUesr:TherapistScheduleDto[],
    gf:GFNo,
    hubUrl:string,
    addionModules:{DevKey:string,Module:string}[],
    cmsReports?:CmsPrintReport[],
    log:any,
}

export interface CmsPrintReport {
    Code:string;
    Template:string;
    Type:number;
}

export interface GFNo {
    Is多媒體候診:boolean;
    Is二維條碼:boolean;
    Is衛星藥局:boolean;
    IsNIISEnable:boolean;
    Is護理站Enable:boolean;
    Is戒菸APIEnable:boolean;
    Is兒健APIEnable:boolean;
    Is新兒健APIEnable:boolean;
    Is無網掛:boolean;
    IsWroom候診:boolean;
    IsWroom網掛:boolean;
    IsWroom只能查詢:boolean;
    Is翔評診後評價:boolean;
    Is翔評預約提醒:boolean;
    Is虛擬卡:boolean;
    IsWebHIS:boolean;
    Is無家護:boolean;
    Is家護收案:boolean;
    ClinicCode4:string;
}
